module.exports = __webpack_public_path__ + "img/hys-4.eaa957c4.jpg";